/**
 * Validators for Subaccount Form
 */

export interface ValidationResult {
  isValid: boolean
  message: string
}

/**
 * Valida formato de email
 */
export function validateEmail(email: string): ValidationResult {
  if (!email) {
    return { isValid: false, message: 'Email é obrigatório' }
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(email)) {
    return { isValid: false, message: 'Formato de email inválido' }
  }

  return { isValid: true, message: 'Email válido' }
}

/**
 * Valida formato de telefone brasileiro
 * Aceita: (XX) XXXXX-XXXX ou (XX) XXXX-XXXX
 */
export function validatePhone(phone: string): ValidationResult {
  if (!phone) {
    return { isValid: false, message: 'Telefone é obrigatório' }
  }

  // Remove caracteres não numéricos para validação
  const numbersOnly = phone.replace(/\D/g, '')

  if (numbersOnly.length < 10 || numbersOnly.length > 11) {
    return {
      isValid: false,
      message: 'Telefone deve ter 10 ou 11 dígitos'
    }
  }

  // Valida formato com máscara
  const phoneRegex = /^\(\d{2}\)\s?\d{4,5}-?\d{4}$/
  if (!phoneRegex.test(phone)) {
    return {
      isValid: false,
      message: 'Use o formato: (XX) XXXXX-XXXX'
    }
  }

  return { isValid: true, message: 'Telefone válido' }
}

/**
 * Valida nome da conta
 */
export function validateAccountName(name: string): ValidationResult {
  if (!name) {
    return { isValid: false, message: 'Nome é obrigatório' }
  }

  if (name.length < 3) {
    return { isValid: false, message: 'Nome deve ter pelo menos 3 caracteres' }
  }

  if (name.length > 100) {
    return { isValid: false, message: 'Nome deve ter no máximo 100 caracteres' }
  }

  return { isValid: true, message: 'Nome válido' }
}

/**
 * Valida código de licença
 */
export function validateLicenseCode(code: string): ValidationResult {
  if (!code) {
    return { isValid: false, message: 'Código de licença é obrigatório' }
  }

  if (code.length < 3) {
    return { isValid: false, message: 'Código de licença inválido' }
  }

  return { isValid: true, message: 'Código válido' }
}

/**
 * Aplica máscara de telefone brasileiro ao digitar
 */
export function applyPhoneMask(value: string): string {
  // Remove tudo que não é número
  const numbers = value.replace(/\D/g, '')

  // Limita a 11 dígitos
  const limited = numbers.slice(0, 11)

  // Aplica a máscara
  if (limited.length <= 2) {
    return limited
  } else if (limited.length <= 6) {
    return `(${limited.slice(0, 2)}) ${limited.slice(2)}`
  } else if (limited.length <= 10) {
    return `(${limited.slice(0, 2)}) ${limited.slice(2, 6)}-${limited.slice(6)}`
  } else {
    return `(${limited.slice(0, 2)}) ${limited.slice(2, 7)}-${limited.slice(7)}`
  }
}

/**
 * Remove máscara do telefone para enviar ao backend
 */
export function removePhoneMask(phone: string): string {
  return phone.replace(/\D/g, '')
}
